import React from "react"
import { Container } from "@carrotfertility/carotene"
import { Form } from "components/views/atoms/forms/Form"
import { FormProvider, useForm } from "react-hook-form"
import { BenefitEnrollmentFlowModalBackButton } from "."

interface EnrollmentStepFormLayoutProps {
  onSubmit: (...args: any[]) => void
  children: React.ReactNode | React.ReactNodeArray
}
export default function EnrollmentStepFormLayout({ onSubmit, children }: EnrollmentStepFormLayoutProps): JSX.Element {
  const formMethods = useForm()
  return (
    <FormProvider {...formMethods}>
      <Form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <Container padding="none" stack="huge">
          <BenefitEnrollmentFlowModalBackButton />
        </Container>
        {children}
      </Form>
    </FormProvider>
  )
}
